import { render, staticRenderFns } from "./StandardPlan.vue?vue&type=template&id=5612417e"
import script from "./StandardPlan.vue?vue&type=script&lang=js"
export * from "./StandardPlan.vue?vue&type=script&lang=js"
import style0 from "./StandardPlan.vue?vue&type=style&index=0&id=5612417e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports